import { configuration } from '../../../infrastructure/clientConfigurationProvider';

import { buildStringFromParams } from './queryStringBuilder';
const purcsUrl = 'https://lookup.previews.cimpress.io/api/';

export function getPurcsUrlForImageWidth(
  tenant: string,
  locale: string,
  productKey: string,
  productVersion: number,
  optionSelections: string,
  instructionsUri: string,
  purpose: string,
  width: number
): string {
  const purcsParams = {
    productVersion: productVersion,
    previewInstructionsUri: instructionsUri,
    purpose,
    optionSelections,
    width,
    requester: configuration.requestor,
  };

  const paramsQueryString = buildStringFromParams(purcsParams);

  const url = `${purcsUrl}v1/${tenant}-prod/${locale}/product/${productKey}/defaultViewImage?${paramsQueryString}`;
  return url;
}
